import utils from '../utils/utils';


export default {
    /**
     * https://github.com/InjectiveLabs/injective-ts/blob/dev/packages/sdk-ts/src/utils/address.ts
     * 
     * @param {*} address 
     * @param {*} currency 
     * @param {*} networkType 
     * @returns boolean
     */
    isValidAddress(address, currency, networkType) {
        try {
            const decoded = utils.bech32.decode(address);
            return decoded.hrp === 'inj' && decoded.data.length === 32;
        } catch (error) {
            return false;
        }
    },
};
